import { render, staticRenderFns } from "./ProgramSponsorsList.vue?vue&type=template&id=c6dd4e5a&"
import script from "./ProgramSponsorsList.vue?vue&type=script&lang=js&"
export * from "./ProgramSponsorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports